import { Outlet } from "react-router-dom";
import Lottie from "lottie-react";
import blobAnimation1 from "../Assets/lottie/blob.json";
import blobAnimation2 from "../Assets/lottie/blob.json";
import lineAnimation1 from "../Assets/lottie/line.json";
import lineAnimation2 from "../Assets/lottie/line.json";

const Layout = () => {
  return (
    <main className="App" style={{ position: "relative", overflow: "hidden" }}>
      {/* Blob 1 */}
      <div
        style={{
          position: "absolute",
          top: "-20%",
          left: "-20%",
          width: "70%",
          height: "70%",
          zIndex: -1,
          opacity: 0.7,
        }}
      >
        <Lottie
          animationData={blobAnimation1}
          loop={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Blob 2 */}
      <div
        style={{
          position: "absolute",
          bottom: "-20%",
          right: "-20%",
          width: "70%",
          height: "70%",
          zIndex: -1,
          opacity: 0.7,
          transform: "rotate(180deg)",
        }}
      >
        <Lottie
          animationData={blobAnimation2}
          loop={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Line 1 */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          right: "-10%",
          width: "50%",
          height: "50%",
          zIndex: -1,
          opacity: 0.5,
        }}
      >
        <Lottie
          animationData={lineAnimation1}
          loop={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Line 2 */}
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          left: "-10%",
          width: "50%",
          height: "50%",
          zIndex: -1,
          opacity: 0.5,
          transform: "rotate(90deg)",
        }}
      >
        <Lottie
          animationData={lineAnimation2}
          loop={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      <Outlet />
    </main>
  );
};

export default Layout;
